export class ModalConfirm {
  public constructor(
    pageTitle?: string,
    pageMessage?: string,
    buttonText?: string,
    returnAcceptMethod?: string,
    returnDenyMethod?: string,
  ) {
    if (pageMessage == null) {
      this.pageMessage = 'DeleteMessage';
    } else {
      this.pageMessage = pageMessage;
    }

    if (buttonText == null) {
      this.buttonText = 'ConfirmButton';
    } else {
      this.buttonText = buttonText;
    }

    if (pageTitle == null) {
      this.pageTitle = 'DeleteTitle';
    } else {
      this.pageTitle = pageTitle;
    }

    if (returnAcceptMethod == null) {
      this.returnAcceptMethod = 'ConfirmDelete';
    } else {
      this.returnAcceptMethod = returnAcceptMethod;
    }

    if (returnDenyMethod == null) {
      this.returnDenyMethod = 'NotDelete';
    } else {
      this.returnDenyMethod = returnDenyMethod;
    }
  }

  public pageTitle: string;
  public pageMessage: string;
  public buttonText: string;
  public returnAcceptMethod: string;
  public returnDenyMethod: string;
}
